import "./FooterStyles.css";

import React from 'react'

import { NavLink } from "react-router-dom";

import { FaLinkedin } from "react-icons/fa";

const Footer = () => {

    const today = new Date();
    const year = today.getFullYear();

  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <h4>Hecho con ❤️ por <NavLink to="https://github.com/ArturoCode" target={"_blank"} style={{color:"rgb(248, 217, 15)"}}>ArturoCode</NavLink>
                <small> © {year} </small>
                </h4>
            </div>
            <div className="right">
                <div className="social">
                <NavLink to="https://www.linkedin.com/in/arturo-urbanos-vara" target={"_blank"}><FaLinkedin size={20} style={{color: "#fff"}} /></NavLink>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer